export const messages = {
  defaultLabel: {
    id: "google-location-input.label",
    defaultMessage: "Location",
  },
};
